import axios from "axios"
import shp from "shpjs"
import { FUNCXml2Json, FUNCIsXml } from "src/config"
import { APIURL } from "src/config/helpers/base"
import get from 'lodash/get';
import {
    contact,
    summary,
    spatialInfo,
    reference,
    identification,
    distributor,
    onlineResources
} from 'src/config/helpers/mappingSpatial'
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import {doughnutBgColor, doughnutBorderColor} from '../../helpers/randomColor'

export const setDataDatasets = (rows = 10, pageNum = 1, sort = 1, search = '', tag = '') => {
    return (dispatch) => {
        dispatch({ type: 'DATA_DATASETS', payload: false })
        axios.get(`${APIURL}/one/Dataset/GetDatasets?Search=${search}&Rows=${rows}&PageNum=${pageNum}&Sort=${sort}`).then(res => {
            var data = res.data;
            dispatch({ type: 'DATA_DATASETS', payload: data.Datasets })
            dispatch({ type: 'TOT_PAGE_DATASETS', payload: data.TotPage })
            dispatch({ type: 'TOT_RESULT_DATASETS', payload: data.TotResult })
        })
    }
}

export const setDataDataset = (slug) => {
    return (dispatch) => {
        dispatch({ type: 'DATA_DATASET', payload: false })
        dispatch({ type: 'DATA_DETAIL_DATASET', payload: false })
        dispatch({ type: 'DATA_SPASIAL_METADATA_XML_ARCGIS', payload: false })
        dispatch({ type: 'DATA_SPASIAL_METADATA_ARCGIS', payload: false })
        dispatch({ type: 'DATA_SPASIAL_TABEL_ARCGIS', payload: false })
        dispatch({ type: 'DATA_SPASIAL_METADATA_XML_GEOSERVER', payload: false })
        dispatch({ type: 'DATA_SPASIAL_METADATA_GEOSERVER', payload: false })
        dispatch({ type: 'DATA_SPASIAL_TABEL_GEOSERVER', payload: false })
        dispatch({ type: 'DATA_SPASIAL_GEOJSON', payload: false })
        dispatch({ type: 'DATA_SPASIAL_TABEL_GEOJSON', payload: false })
        dispatch({ type: 'DATA_SPASIAL_SHP', payload: false })
        dispatch({ type: 'DATA_SPASIAL_METADATA_XML_SHP', payload: false })
        dispatch({ type: 'DATA_SPASIAL_TABEL_SHP', payload: false })
        dispatch({ type: 'DATA_TABEL_JSON', payload: false })
        dispatch({ type: 'DATA_GRAFIK_RESULT', payload: false })
        dispatch({ type: 'DATA_GRAFIK_AXIS_A', payload: false })
        dispatch({ type: 'DATA_GRAFIK_AXIS_B', payload: false })
        axios.get(`${APIURL}/one/Dataset/GetDataset?DataHeaderSlug=${slug}`).then(res => {
            var data = res.data;
            if (res.status !== 204) {
                dispatch({ type: 'DATA_DATASET', payload: data })
                if (data.DatasetType === 'Excel') dispatch(setDataDetailDataset(slug))

                if (data.GeoportalType === 'arcgisserver') {
                    var urlMetadata = `${data.UrlMetadata}/${data.LayerName}/MapServer/info/metadata?format=iso19139`;
                    axios.get(urlMetadata).then(res => {
                        var data = res.data;
                        dispatch({ type: 'DATA_SPASIAL_METADATA_XML_ARCGIS', payload: data })
                    })
                    axios.get(`${data.UrlMetadata}/${data.LayerName}/MapServer/0/query?where=1%3D1&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&relationParam=&outFields=*&returnGeometry=false&maxAllowableOffset=&geometryPrecision=&outSR=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&returnDistinctValues=false&returnTrueCurves=false&resultOffset=&resultRecordCount=&f=pjson`).then(res => {
                        var data = res.data;
                        var columns = [];
                        var row = [];
                        data.features.map((v, i) => {
                            row.push(v.attributes)
                        })
                        data.fields.map((v, i) => {
                            columns.push({
                                title: v.name.replace(/_/g, ' ').toUpperCase(),
                                field: v.name,
                            });
                        })
                        const datas = {
                            columns: columns,
                            data: row
                        }
                        dispatch({ type: 'DATA_SPASIAL_TABEL_ARCGIS', payload: datas })
                    })
                    var request = new XMLHttpRequest();
                    request.open("GET", urlMetadata, true);
                    request.responseType = 'document';
                    request.overrideMimeType('text/xml');
                    request.onload = function () {
                        if (request.readyState === request.DONE) {
                            if (request.status === 200) {
                                var dataMetadata = FUNCXml2Json(request.responseXML);
                                console.log(dataMetadata)
                                var base = 'metadata.'
                                const outMetaArcgis = [
                                    {
                                        title: 'Data Info',
                                        data: [
                                            {
                                                title: 'Citation',
                                                value: get(dataMetadata, `${base}dataIdInfo.idCitation.resTitle.#text`)
                                            },
                                            {
                                                title: 'Language',
                                                value: get(dataMetadata, `${base}@attributes.xml:lang`)
                                            },
                                        ],
                                    },
                                    {
                                        title: 'Esri',
                                        data: [
                                            {
                                                title: 'Format',
                                                value: get(dataMetadata, `${base}Esri.ArcGISFormat.#text`)
                                            },
                                            {
                                                title: 'Create Date',
                                                value: get(dataMetadata, `${base}Esri.CreaDate.#text`)
                                            },
                                            {
                                                title: 'Create Time',
                                                value: get(dataMetadata, `${base}Esri.CreaTime.#text`)
                                            },
                                            {
                                                title: 'Sync Once',
                                                value: get(dataMetadata, `${base}Esri.SyncOnce.#text`)
                                            },
                                        ],
                                    }
                                ];
                                dispatch({ type: 'DATA_SPASIAL_METADATA_ARCGIS', payload: outMetaArcgis })
                            }
                        }
                    };
                    request.send(null);
                }
                if (data.GeoportalType === 'geoserver') {
                    var pecahUrl = data.LayerName.split(':')[0];
                    var layerWms = `${data.UrlGeoportal}/${pecahUrl}/wms/?service=WFS&version=1.0.0&request=GetFeature&typeName=${data.LayerName}&maxFeatures=50&outputFormat=application%2Fjson`;
                    axios.get(layerWms).then(res => {
                        var datags = res.data;
                        dispatch({ type: 'DATA_SPASIAL_GEOSERVER', payload: datags })
                        var dataColumns = [];
                        var row = [];
                        var columns = [];
                        datags.features.map((v, i) => {
                            dataColumns = Object.keys(v.properties);
                            row.push(v.properties)
                        })

                        dataColumns.map((v, i) => {
                            columns.push({
                                title: v.replace(/_/g, ' ').toUpperCase(),
                                field: v,
                            });
                        });
                        const datas = {
                            columns: columns,
                            data: row
                        }
                        dispatch({ type: 'DATA_SPASIAL_TABEL_GEOSERVER', payload: datas })
                    })

                    axios.get(`${data.UrlMetadata}?service=CSW&version=2.0.2&request=GetRecordById&ElementSetName=full&Id=${data.LayerName}&outputSchema=http://www.isotc211.org/2005/gmd&outputFormat=application/xml`).then(res => {
                        dispatch({ type: 'DATA_SPASIAL_METADATA_XML_GEOSERVER', payload: res.data })
                    })
                    axios.get(`${data.UrlMetadata}?service=CSW&version=2.0.2&request=GetRecordById&ElementSetName=full&Id=${data.LayerName}&outputSchema=http://www.isotc211.org/2005/gmd&outputFormat=application/json`).then(res => {
                        var rawMetadata = res.data;
                        const outMetaGeom = [
                            summary(rawMetadata),
                            identification(rawMetadata),
                            spatialInfo(rawMetadata),
                            reference(rawMetadata),
                            contact(rawMetadata),
                            distributor(rawMetadata),
                            ...onlineResources(rawMetadata)
                        ];
                        dispatch({ type: 'DATA_SPASIAL_METADATA_GEOSERVER', payload: outMetaGeom })
                    })
                }
                if (data.DatasetType === 'File SHP (ZIP)') {
                    if (data.DataHeaderUrlData !== null) {
                        var promise = new JSZip.external.Promise(function (resolve, reject) {
                            // JSZipUtils.getBinaryContent('http://localhost:3000/00_DATA_SAWAH_MUBA.zip', function (err, data) {
                            JSZipUtils.getBinaryContent(data.DataHeaderUrlData, function (err, data) {
                                if (err) {
                                    reject(err);
                                } else {
                                    resolve(data);
                                }
                            });
                        });

                        promise.then(JSZip.loadAsync).then(function (zip) {
                            var i = 0;
                            Object.keys(zip.files).forEach(function (filename) {
                                if (FUNCIsXml(filename)) {
                                    zip.files[filename].async('string').then(function (fileData) {
                                        if (i === 0) {
                                            dispatch({ type: 'DATA_SPASIAL_METADATA_XML_SHP', payload: fileData })
                                        }
                                        i++;
                                    })
                                }
                            })
                        });

                        // fetch(`https://api.satudata.swg.co.id/Assets/Files/Appl/File/opd_10129/sawah-tahun-2020.zip`)       // 1) fetch the url
                        //     .then(function (response) {                       // 2) filter on 200 OK
                        //         if (response.status === 200 || response.status === 0) {
                        //             console.log(response)
                        //             return Promise.resolve(response.blob());
                        //         } else {
                        //             return Promise.reject(new Error(response.statusText));
                        //         }
                        //     })
                        //     .then(zipx.loadAsync)                            // 3) chain with the zip promise
                        //     .then(function (zip) {
                        //         Object.keys(zip.files).forEach(function (filename) {
                        //             zip.files[filename].async('string').then(function (fileData) {
                        //                 console.log(fileData) // These are your file contents      
                        //             })
                        //         })

                        //         // return zip.file("00_DATA_SAWAH_MUBA.shp").async("string"); // 4) chain with the text content promise
                        //     })
                        //     .then(function success(text) {
                        //         console.log(text)              // 5) display the result
                        //         // $("#fetch").append($("<p>", {
                        //         //     "class": "alert alert-success",
                        //         //     text: "loaded, content = " + text
                        //         // }));
                        //     }, function error(e) {
                        //         console.log(e)              // 5) display the result
                        //         // $("#fetch").append($("<p>", {
                        //         //     "class": "alert alert-danger",
                        //         //     text: e
                        //         // }));
                        //     });

                        shp(data.DataHeaderUrlData).then(function (datashp) {
                            dispatch({ type: 'DATA_SPASIAL_SHP', payload: datashp })
                            var dataColumns = [];
                            var row = [];
                            var columns = [];
                            datashp.features.map((v, i) => {
                                dataColumns = Object.keys(v.properties);
                                row.push(v.properties)
                            })

                            dataColumns.map((v, i) => {
                                if (
                                    v === 'tableData'
                                ) {
                                    // console.log('lewat nih bos, senggol dong')
                                } else {
                                    columns.push({
                                        title: v.replace(/_/g, ' ').toUpperCase(),
                                        field: v,
                                    });
                                }
                            });
                            const datas = {
                                columns: columns,
                                data: row
                            }
                            dispatch({ type: 'DATA_SPASIAL_TABEL_SHP', payload: datas })
                        });
                    }
                }
                if (data.DatasetType === 'GeoJson') {
                    if (data.DataHeaderUrlData !== null) {
                        axios.get(data.DataHeaderUrlData).then(res => {
                            var dataGeoJson = res.data;
                            dispatch({ type: 'DATA_SPASIAL_GEOJSON', payload: dataGeoJson })
                            var dataColumns = [];
                            var row = [];
                            var columns = [];
                            dataGeoJson.features.map((v, i) => {
                                dataColumns = Object.keys(v.properties);
                                var array2 = {}
                                Object.keys(v.properties).map((vx, i) => {
                                    var makan = v.properties[vx];
                                    if (
                                        typeof v.properties[vx] === 'object' &&
                                        !Array.isArray(v.properties[vx]) &&
                                        v.properties[vx] !== null
                                    ) {
                                        makan = "[object Object]"
                                    }
                                    array2[vx] = makan;
                                })
                                row.push(array2);
                            })

                            dataColumns.map((v, i) => {
                                columns.push({
                                    title: v.replace(/_/g, ' ').toUpperCase(),
                                    field: v,
                                });
                            });
                            const datas = {
                                columns: columns,
                                data: row
                            }
                            // console.log(datas)
                            dispatch({ type: 'DATA_SPASIAL_TABEL_GEOJSON', payload: datas })
                        })
                    }
                }
                if (data.DatasetType === 'Json') {
                    if (data.DataHeaderUrlData !== null) {
                        axios.get(data.DataHeaderUrlData).then(res => {
                            var data = res.data;
                            if (data.length != 0) {
                                var dataColumns = [];
                                var row = [];
                                var columns = [];
                                data.map((v, i) => {
                                    dataColumns = Object.keys(v);
                                    row.push(v)
                                })


                                dataColumns.map((v, i) => {
                                    columns.push({
                                        title: v.replace(/_/g, ' ').toUpperCase(),
                                        field: v,
                                    });
                                });
                                const datas = {
                                    columns: columns,
                                    data: row
                                }
                                dispatch({ type: 'DATA_TABEL_JSON', payload: datas })
                            }
                        })
                    }
                }

                var axisA = []
                var axisB = []
                data.Fields.map((v, i) => {
                    var obj = {
                        label: v.Title.replace(/_/g, ' ').toUpperCase(),
                        value: v.Name.toLowerCase(),
                    };
                    if (v.FieldType === 'string') {
                        axisA.push(obj)
                    } else {
                        axisB.push(obj)
                    }
                })
                dispatch({ type: 'DATA_GRAFIK_AXIS_A', payload: axisA })
                dispatch({ type: 'DATA_GRAFIK_AXIS_B', payload: axisB })
            } else {
                dispatch({ type: 'DATA_DATASET', payload: null })
            }
        })
    }
}

export const setDataDatasetGroup = () => {
    return (dispatch) => {
        dispatch({ type: 'DATA_DATASET_GROUP', payload: false })
        axios.get(`${APIURL}/one/Dataset/GetDatasetGroupList`).then(res => {
            var data = res.data;
            setTimeout(() => {
                dispatch({ type: 'DATA_DATASET_GROUP', payload: data })
            }, 1000);
        })
    }
}



export const setDataTags = () => {
    return (dispatch) => {
        dispatch({ type: 'DATA_TAGS', payload: false })
        axios.get(`${APIURL}/Tag/GetList`).then(res => {
            var data = res.data;
            if (data.IsSuccess) {
                setTimeout(() => {
                    dispatch({ type: 'DATA_TAGS', payload: data.Data })
                }, 1000);
            } else {

            }
        })
    }
}

export const setDataDetailDataset = (slug) => {
    return (dispatch) => {
        dispatch({ type: 'DATA_TAGS', payload: false })
        axios.get(`${APIURL}/one/Dataset/GetData?Slug=${slug}`).then(res => {
            var data = res.data;
            if (data.length !== 0) {
                var dataColumns = Object.keys(data[0]);
                var columns = [];
                dataColumns.map((v, i) => {
                    columns.push({
                        title: v.replace(/_/g, ' ').toUpperCase(),
                        field: v,
                    });
                });
                const dataDetailDataset = {
                    columns: columns,
                    data
                }
                // dispatch({ type: 'DATA_GRAFIK_AXIS_A', payload: columns })
                // dispatch({ type: 'DATA_GRAFIK_AXIS_B', payload: columns })
                dispatch({ type: 'DATA_DETAIL_DATASET', payload: dataDetailDataset })
            }

        })
    }
}

export const setDataPritinjauGrafik = (idA, idB, gayaGrafik, data) => {
    return (dispatch) => {
        var labelA = []
        var labelB = []
        var labelBgColor = []
        var labelBorderColor = []
       
        Object.keys(data).map(v => {
            labelA.push(data[v][idA])
            labelB.push(data[v][idB])
            labelBgColor.push(doughnutBgColor[v])
            labelBorderColor.push(doughnutBorderColor[v])
        })

        var dataGrafik;
        if (gayaGrafik === 'Bar Chart') {
            dataGrafik = {
                labels: labelA,
                datasets: [
                    {
                        label: idA.toUpperCase(),
                        backgroundColor: 'rgb(145 187 234)',
                        borderColor: 'rgb(39 112 193)',
                        borderWidth: 1,
                        hoverBackgroundColor: 'rgb(145 187 234)',
                        hoverBorderColor: 'rgb(39 112 193)',
                        data: labelB
                    }
                ]
            };
        }
        if (gayaGrafik === 'Doughnut') {
            dataGrafik = {
                labels: labelA,
                datasets: [
                    {
                        label: idA.toUpperCase(),
                        data: labelB,
                        backgroundColor: labelBgColor,
                        borderColor: labelBorderColor,
                        borderWidth: 1,
                    },
                ],
            };
        }
        if (gayaGrafik === 'Line Chart') {
            dataGrafik = {
                labels : labelA,
                datasets: [
                    {
                        label: idA.toUpperCase(),
                        data: labelB,
                        borderColor: 'rgb(39 112 193)',
                        backgroundColor: 'rgb(145 187 234)',
                    }
                ],
            };
        }
        
        dispatch({ type: 'DATA_GRAFIK_RESULT', payload: dataGrafik })
    }
}